<script>
import { onMounted } from 'vue'
import interceptors from '../../utils/interceptors'

export default {
  name: 'interceptors',
  template: '<div></div>',
  props: ['axios'],
  setup (props) {
    onMounted(() => {
      interceptors.setup(props.axios)
    })
  }
}
</script>
